module.exports = __webpack_public_path__ + "img/plus.a19c7869.svg";